const ENDPOINT = '/api/2026-01/graphql.json';
const MUTATION = `mutation P($lines:[CartLineInput!]!) @inContext(country: US) { cartCreate(input:{lines:$lines}) { cart { cost { subtotalAmount{amount} } discountAllocations { discountedAmount{amount} } lines(first:50){ nodes { cost { subtotalAmount{amount} } } } } userErrors { message } } }`;
const TIMEOUT_MS = 4000;

const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
const toCents = (amount) => Math.round(parseFloat(amount) * 100);
const pct = (o, f) => Math.round(((o - f) * 100) / o);

function previewWorker() {
  self.onmessage = async ({ data }) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), data.timeout);
    try {
      const response = await fetch(data.url, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: data.query, variables: { lines: data.lines } }),
        signal: controller.signal,
      });
      self.postMessage({ ok: response.ok, status: response.status, body: await response.json() });
    } catch (err) {
      self.postMessage({ error: err?.name === 'AbortError' ? 'timeout' : String(err?.message ?? err) });
    } finally {
      clearTimeout(timeout);
    }
  };
}

function createCart(lines) {
  return new Promise((resolve, reject) => {
    let worker;
    try {
      worker = new Worker(URL.createObjectURL(new Blob([`(${previewWorker})()`], { type: 'text/javascript' })));
    } catch (err) {
      reject(err);
      return;
    }
    const finish = (settle, value) => {
      worker.terminate();
      settle(value);
    };
    worker.onmessage = ({ data }) => (data.error ? finish(reject, new Error(data.error)) : finish(resolve, data));
    worker.onerror = (event) => finish(reject, new Error(event.message || 'worker failed'));
    worker.postMessage({ url: new URL(ENDPOINT, location.origin).href, query: MUTATION, lines, timeout: TIMEOUT_MS });
  });
}

function parseLines(dataLines) {
  return dataLines.split(',').map((piece) => {
    const [id, quantity] = piece.split(':');
    return { merchandiseId: `gid://shopify/ProductVariant/${id}`, quantity: Number(quantity) };
  });
}

async function cartTotals(lines) {
  const { ok, status, body } = await createCart(lines);
  if (!ok) throw new Error(`HTTP ${status}`);
  const cart = body?.data?.cartCreate?.cart;
  if (!cart || body.data.cartCreate.userErrors.length) throw new Error('cart not created');
  if (cart.lines.nodes.length !== lines.length) throw new Error('line count mismatch');
  const orderOff = (cart.discountAllocations || []).reduce((sum, a) => sum + toCents(a.discountedAmount.amount), 0);
  const f = toCents(cart.cost.subtotalAmount.amount) - orderOff;
  const o = cart.lines.nodes.reduce((sum, node) => sum + toCents(node.cost.subtotalAmount.amount), 0);
  if (f <= 0) throw new Error('empty cart total');
  return { o, f };
}

function showSavings(el, o, f) {
  el.querySelectorAll('.tv-atfp__was-label, .tv-atfp__was, .tv-atfp__pct').forEach((node) => node.remove());
  if (o <= f || pct(o, f) <= 0) return;
  const label = Object.assign(document.createElement('span'), { className: 'visually-hidden tv-atfp__was-label', textContent: 'Bought separately' });
  const was = Object.assign(document.createElement('s'), { className: 'tv-atfp__was', textContent: money(o) });
  const off = Object.assign(document.createElement('span'), { className: 'tv-atfp__pct', textContent: `You save $${Math.floor((o - f) / 100).toLocaleString('en-US')} (${pct(o, f)}%)` });
  el.append(' ', label, was, ' ', off);
}

async function refresh(el) {
  try {
    const { o, f } = await cartTotals(parseLines(el.dataset.lines));
    el.querySelector('.tv-atfp__now').textContent = money(f);
    showSavings(el, o, f);
  } catch (err) {
    console.warn('[tv-atfp] keeping first-paint price:', err.message);
  }
}

if (window.matchMedia('(max-width: 749px)').matches) {
  document.querySelectorAll('[data-tv-atfp-set]').forEach(refresh);
}
